import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button, { ButtonProps } from 'vibo-ui/Button';

import { ReactComponent as AppleLogoIcon } from 'resources/img/svg/appleLogo.svg';

import useStyles from './style';

const AppleButton: FC<ButtonProps> = ({ className, ...rest }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button
      prefixIcon={AppleLogoIcon}
      className={classNames('appleLoginButton', classes.appleLoginButton, className)}
      displayType="primary"
      shape="round"
      size="lg"
      {...rest}
    >
      {t('signInApple')}
    </Button>
  );
};

export default AppleButton;
